var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Home Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46.4 15.6c0.2 0.1 0.4 0.1 0.5 0.1 0.4 0 0.7-0.2 1-0.5 0.3-0.5 0.1-1.2-0.4-1.5l-23-13.3h-0.1c-0.1 0-0.1-0.1-0.2-0.1h-0.2-0.2c-0.1 0-0.1 0-0.2 0.1h-0.1l-23 13.3c-0.5 0.3-0.7 1-0.4 1.5 0.2 0.4 0.6 0.5 0.9 0.5 0.2 0 0.4 0 0.6-0.2l2-1.2v27.3h-2.5c-0.4 0-0.7 0.3-0.7 0.7s0.3 0.7 0.7 0.7h45.8c0.4 0 0.7-0.3 0.7-0.7s-0.3-0.7-0.7-0.7h-2.7v-27.2l2.2 1.2zm-27.7 10.8h10.5v15.4h-10.5v-15.4zm23.3 15.3h-11.3v-16c0-0.4-0.3-0.7-0.7-0.7h-0.1-0.1-11.8c-0.4 0-0.7 0.3-0.7 0.7v16.1h-11.4v-28.6l18-10.6 18.1 10.5v28.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.611712b69edd033ede06d30184f4bc51.svg";
export { ForwardRef as ReactComponent };